import React from 'react';

import Loader from '@/assets/icons/Loader';
import * as Dialog from '@radix-ui/react-dialog';

import styles from './LoaderWithOverlay.module.css';

type LoaderProps = {
  isLoading: boolean;
  handleOpenChange: (p: boolean) => void;
  overlayOpacity?: 'nonTransparant' | 'transparant';
};

export const LoaderWithOverlay = ({ isLoading, handleOpenChange, overlayOpacity = 'nonTransparant' }: LoaderProps) => {
  return (
    <Dialog.Root open={isLoading} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          className={[
            styles.dialogOverlayLoaderStyle,
            overlayOpacity === 'nonTransparant' && styles['dialogOverlayLoaderStyle--overlayOpacity-nonTransparant'],
            overlayOpacity === 'transparant' && styles['dialogOverlayLoaderStyle--overlayOpacity-transparant'],
          ]
            .filter(Boolean)
            .join(' ')}
        />
        <div data-testid='is-loading' style={{ position: 'absolute', top: '30%', left: '49%', zIndex: '101' }}>
          <Loader width='40px' height='40px' className={styles.loadingIconStyle} aria-hidden='true' />
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
